function getProfilesFromLocalStorage() {
  return JSON.parse(localStorage.getItem('profiles') as string) ?? {};
}

export default getProfilesFromLocalStorage;
